//  so this takes the base/default classof a component as an argument, and then appends any other classname to it depending on a boolean prop
//  e.g. rounded prop is passed as true, therefore classname styles.rounded can be added.
var propsToClass = (baseClass, propClassArray) => propClassArray.reduce((a, [className, hasProp]) => (hasProp ? `${a} ${className}` : a), baseClass);

export { propsToClass as default };
//# sourceMappingURL=propsToClass.js.map
